import React from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../Pagination';
import PageSizeSelect from './PageSizeSelect';

const PaginationControls = ({
  pageSizeOptions,
  pageSize,
  onChangePageSize,
  currentPage,
  totalItems,
  onChangePage,
  classNameContainer,
  classNamePagination,
}) => {
  return (
    <div className={classNameContainer}>
      <PageSizeSelect
        options={pageSizeOptions}
        value={pageSize}
        onChange={onChangePageSize}
      />
      <Pagination
        pageSize={pageSize.value}
        current={currentPage}
        total={totalItems}
        onChange={onChangePage}
        className={classNamePagination}
      />
    </div>
  );
};

PaginationControls.propTypes = {
  pageSizeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  pageSize: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onChangePageSize: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  totalItems: PropTypes.number,
  onChangePage: PropTypes.func.isRequired,
  classNameContainer: PropTypes.string,
  classNamePagination: PropTypes.string,
};

PaginationControls.defaultProps = {
  currentPage: 1,
  totalItems: 0,
  classNameContainer: '',
  classNamePagination: '',
};

export default PaginationControls;
